// extracted by mini-css-extract-plugin
export default {"statistic":"Statistic_statistic__u1raK","suffix":"Statistic_suffix__BQQ+R","title":"Statistic_title__hFV8u"};